/** @jsxRuntime classic*/
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React, { Fragment } from 'react';
import { useEffect, useRef, useState } from 'react';
import { Tooltip } from '../../components/Tooltip';
import { useColors } from '../../hooks/useColors';

const textCss = (color?: string, width?: string) => css`
	text-overflow: ellipsis;
	overflow: hidden;
	max-width: ${width ? width : 'unset'};
	white-space: nowrap;
	display: block !important; //becaue sometimes we have parrent componet that chnange all span syles
	color: ${color};
	font-size: 14px;
	line-height: 20px;
	font-weight: 500;
	font-family: Montserrat;
	font-style: normal;
`;

interface Props {
	text: string;
	color?: string;
	width?: string;
}
export const TruncateWithTooltip = ({ text, color, width }: Props) => {
	const { colors } = useColors();
	const textRef = useRef<HTMLDivElement>(null);
	const [isTruncated, setIsTruncated] = useState(false);

	useEffect(() => {
		if (textRef.current) {
			setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
		}
	}, [textRef.current]);

	const textContent = (
		<span ref={textRef} css={textCss(color || colors.bg_text_primary, width)} data-aid="TruncateWithTooltip-text">
			{text}
		</span>
	);

	return (
		<Fragment>
			{isTruncated ? (
				<Tooltip content={text} isTopLayer>
					{textContent}
				</Tooltip>
			) : (
				textContent
			)}
		</Fragment>
	);
};
